/**
 * Field System — single entry point for product form fields.
 *
 * Change specs in one of these files:
 *   1. Tokens (radius, focus, typography) → src/styles/field-tokens.css
 *   2. Component presets (Default, Inline, Full, …) → fieldClassNames.js
 *   3. Dropdown shell + panel CSS          → src/styles/field-components.css
 *
 * Intentionally custom (do not migrate): Help Centre hero search — HelpCenterLayout.js
 * Category filters keyword search — SearchInput.js
 */

export const FIELD_DEFAULT_VARIANT = {
  text: "large",
  dropdown: "large",
  password: "large",
  textarea: "page",
};

export const FIELD_DROPDOWN = {
  panelClassName: "custom-dropdown-panel",
  wrapperClassName: "custom-dropdown",
};

/** Verification group modifiers — 4 or 6 digits (spec §7) */
export const FIELD_VERIFICATION_GROUP = {
  four: "field-verification-group field-verification-group--4",
  six: "field-verification-group field-verification-group--6",
};

export {
  FIELD_BASE,
  FIELD_DEFAULT,
  FIELD_DEFAULT_FULL,
  FIELD_FULL_WIDTH_VARIANT_MAP,
  FIELD_INLINE_96,
  FIELD_INLINE_120,
  FIELD_INLINE_140,
  FIELD_INLINE_160,
  FIELD_INLINE_240,
  FIELD_PAGE,
  FIELD_PAGE_FULL,
  FIELD_PAGE_TEXTAREA,
  FIELD_PAGE_TEXTAREA_FULL,
  FIELD_SEARCH,
  FIELD_SEARCH_FULL,
  FIELD_UPLOAD,
  FIELD_UPLOAD_FULL,
  FIELD_CHIPS,
  FIELD_CHIPS_FULL,
  FIELD_VERIFICATION_DIGIT_CLASS,
  INPUT_FIELD_VARIANT_CLASSES,
  resolveFieldVariant,
} from "./fieldClassNames";
